<template>
  <v-dialog v-model="open" persistent max-width="390">
    <v-card tile>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline font-weight-bold text-center px-md-10">
          Item Saved
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon color="black" large>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pt-2 pb-0">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6" class="text-center">
            <p class="body-1">
              {{ resourceName }} was successfully save to {{ listName }} list.
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center py-6 d-flex">
        <v-btn
          color="primary"
          rounded
          class="text-none"
          :to="`/profile?tab=saved&list=${listId}`"
          nuxt
          style="min-width: 15rem;"
        >
          Go to list
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    resourceName: {
      type: String,
      required: true,
    },
    listName: {
      type: String,
      required: true,
    },
    listId: {
      type: String,
      required: true,
    },
  },
}
</script>

<style></style>
